import { CwsDivider, CwsH3 } from '@components/cws'
import type { FC } from 'react'
import { useTranslate } from '@hooks/useTranslation'
import { useRouter } from 'next/router'
import AdyenPayment from '@components/cart/payment/PaymentMethods/AdyenPayment'
import { PaymentVariant } from '@components/cart/payment/PaymentMethods/PaymentVariant'

export interface PaymentMethodsProps {
  ssoToken?: string
}

export const PaymentMethods: FC<PaymentMethodsProps> = ({ ssoToken }) => {
  const { translate } = useTranslate()
  const { locale } = useRouter()

  return (
    <>
      <CwsH3 textAlign="left">{translate('cart.payment.title')}</CwsH3>
      {['fi', 'lv', 'lt'].includes(locale ?? 'et') ? (
        <>
          <CwsDivider />
          <AdyenPayment ssoToken={ssoToken} />
        </>
      ) : (
        <PaymentVariant />
      )}
    </>
  )
}
